import { ReactElement } from 'react';
import BackgroundAndIdentityDetails from '@components/FVSPage/BackgroundAndIdentityDetails';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep8(): ReactElement {
  return (
    <>
      <BackgroundAndIdentityDetails displayObject={fvsInfoDisplayObject} currentStepNo="step8" />
    </>
  );
}

export default FVSStep8;
